export interface Props {
  className?: string;
}

export function PreloaderStarsIcon({className}: Props): JSX.Element {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g filter="url(#filter0_f_12837_150177)">
        <path
          d="M104 39L104.476 41.223C104.595 41.7768 104.986 42.2328 105.515 42.4344L107 43L105.515 43.5656C104.986 43.7672 104.595 44.2232 104.476 44.777L104 47L103.524 44.777C103.405 44.2232 103.014 43.7672 102.485 43.5656L101 43L102.485 42.4345C103.014 42.2328 103.405 41.7768 103.524 41.223L104 39Z"
          fill="#FFDD2D"
        />
      </g>
      <g filter="url(#filter1_f_12837_150177)">
        <path
          d="M51 71L51.4764 73.223C51.595 73.7768 51.9862 74.2328 52.5154 74.4344L54 75L52.5154 75.5656C51.9862 75.7672 51.595 76.2232 51.4764 76.777L51 79L50.5236 76.777C50.405 76.2232 50.0138 75.7672 49.4846 75.5656L48 75L49.4846 74.4345C50.0138 74.2328 50.405 73.7768 50.5236 73.223L51 71Z"
          fill="#3BE1FF"
        />
      </g>
      <g filter="url(#filter2_f_12837_150177)">
        <path
          d="M122 65L122.476 67.223C122.595 67.7768 122.986 68.2328 123.515 68.4344L125 69L123.515 69.5656C122.986 69.7672 122.595 70.2232 122.476 70.777L122 73L121.524 70.777C121.405 70.2232 121.014 69.7672 120.485 69.5656L119 69L120.485 68.4345C121.014 68.2328 121.405 67.7768 121.524 67.223L122 65Z"
          fill="#3BE1FF"
        />
      </g>
      <g filter="url(#filter3_f_12837_150177)">
        <path
          d="M107 134L107.476 136.223C107.595 136.777 107.986 137.233 108.515 137.434L110 138L108.515 138.566C107.986 138.767 107.595 139.223 107.476 139.777L107 142L106.524 139.777C106.405 139.223 106.014 138.767 105.485 138.566L104 138L105.485 137.434C106.014 137.233 106.405 136.777 106.524 136.223L107 134Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter4_f_12837_150177)">
        <path
          d="M66 104L66.4764 106.223C66.595 106.777 66.9862 107.233 67.5154 107.434L69 108L67.5154 108.566C66.9862 108.767 66.595 109.223 66.4764 109.777L66 112L65.5236 109.777C65.405 109.223 65.0138 108.767 64.4846 108.566L63 108L64.4846 107.434C65.0138 107.233 65.405 106.777 65.5236 106.223L66 104Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter5_f_12837_150177)">
        <circle cx="134" cy="125" r="1" fill="#C536F2" />
      </g>
      <g opacity="0.4" filter="url(#filter6_f_12837_150177)">
        <circle cx="136" cy="157" r="1" fill="#939EFF" />
      </g>
      <g filter="url(#filter7_f_12837_150177)">
        <circle cx="62" cy="48" r="1" fill="#939EFF" />
      </g>
      <g filter="url(#filter8_f_12837_150177)">
        <circle cx="62" cy="94" r="1" fill="#3CDFFD" />
      </g>
      <g filter="url(#filter9_f_12837_150177)">
        <circle cx="74" cy="123" r="1" fill="#939EFF" />
      </g>
      <g filter="url(#filter10_f_12837_150177)">
        <circle cx="125" cy="77" r="1" fill="#C536F2" />
      </g>
      <g filter="url(#filter11_f_12837_150177)">
        <circle cx="116" cy="63" r="1" fill="#939EFF" />
      </g>
      <g filter="url(#filter12_f_12837_150177)">
        <circle cx="96" cy="62" r="1" fill="#939EFF" />
      </g>
      <g filter="url(#filter13_f_12837_150177)">
        <circle cx="90" cy="40" r="1" fill="#3CDFFD" />
      </g>
      <g filter="url(#filter14_f_12837_150177)">
        <circle cx="87" cy="145" r="1" fill="#3CDFFD" />
      </g>
      <g filter="url(#filter15_f_12837_150177)">
        <circle cx="158" cy="80" r="1" fill="#3CDFFD" />
      </g>
      <g opacity="0.4" filter="url(#filter16_f_12837_150177)">
        <circle cx="166" cy="44" r="1" fill="#3CDFFD" />
      </g>
      <g filter="url(#filter17_f_12837_150177)">
        <circle cx="139" cy="34" r="1" fill="#C536F2" />
      </g>
      <g opacity="0.5" filter="url(#filter18_f_12837_150177)">
        <circle cx="34" cy="140" r="1" fill="#939EFF" />
      </g>
      <g filter="url(#filter19_f_12837_150177)">
        <circle cx="71" cy="156" r="1" fill="#C536F2" />
      </g>
      <g opacity="0.4" filter="url(#filter20_f_12837_150177)">
        <circle cx="36" cy="25" r="1" fill="#939EFF" />
      </g>
      <g opacity="0.4" filter="url(#filter21_f_12837_150177)">
        <circle cx="106" cy="176" r="1" fill="#939EFF" />
      </g>
      <g filter="url(#filter22_f_12837_150177)">
        <circle cx="164" cy="111" r="1" fill="#939EFF" />
      </g>
      <g filter="url(#filter23_f_12837_150177)">
        <circle cx="33" cy="100" r="1" fill="#C536F2" />
      </g>
      <defs>
        <filter
          id="filter0_f_12837_150177"
          x="100.5"
          y="38.5"
          width="7"
          height="9"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.25" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter1_f_12837_150177"
          x="47.5"
          y="70.5"
          width="7"
          height="9"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.25" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter2_f_12837_150177"
          x="118.5"
          y="64.5"
          width="7"
          height="9"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.25" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter3_f_12837_150177"
          x="103.5"
          y="133.5"
          width="7"
          height="9"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.25" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter4_f_12837_150177"
          x="62.5"
          y="103.5"
          width="7"
          height="9"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.25" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter5_f_12837_150177"
          x="132"
          y="123"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter6_f_12837_150177"
          x="134"
          y="155"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter7_f_12837_150177"
          x="60"
          y="46"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter8_f_12837_150177"
          x="60"
          y="92"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter9_f_12837_150177"
          x="72"
          y="121"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter10_f_12837_150177"
          x="123"
          y="75"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter11_f_12837_150177"
          x="114"
          y="61"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter12_f_12837_150177"
          x="94"
          y="60"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter13_f_12837_150177"
          x="88"
          y="38"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter14_f_12837_150177"
          x="85"
          y="143"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter15_f_12837_150177"
          x="156"
          y="78"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter16_f_12837_150177"
          x="164"
          y="42"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter17_f_12837_150177"
          x="137"
          y="32"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter18_f_12837_150177"
          x="32"
          y="138"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter19_f_12837_150177"
          x="69"
          y="154"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter20_f_12837_150177"
          x="34"
          y="23"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter21_f_12837_150177"
          x="104"
          y="174"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter22_f_12837_150177"
          x="162"
          y="109"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
        <filter
          id="filter23_f_12837_150177"
          x="31"
          y="98"
          width="4"
          height="4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_12837_150177" />
        </filter>
      </defs>
    </svg>
  );
}
